import './App.css';
import React from 'react';
import { Button, Card, CardBody, CardTitle, Form, FormGroup, Input, Label, ButtonGroup } from 'reactstrap';
import { useNavigate } from "react-router-dom";

function App() {
  let backEndUrl = localStorage.getItem("be");
  const navigate = useNavigate();
  let phoneNumber = React.createRef();
  let password = React.createRef();
  let newPwd = React.createRef();
  let confirmPwd = React.createRef();
  const [showPassword, setShowPassword] = React.useState(false)
  const [newPassword, setNewPassword] = React.useState(false)
  const [customerData, setcustomerData] = React.useState({});

  const [rSelected, setRSelected] = React.useState(0);
  const userType = ["customer", "partner", "franchise"];

  const checkIfUserExist = async (phoneNumber) => {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };
  
      await fetch(backEndUrl + "api/"+userType[rSelected]+"/" + phoneNumber, requestOptions)
        .then(response => response.text())
        .then(result => {
          let userData = JSON.parse(result);
          console.log(userData);
          setcustomerData(userData);
          if(userData["message"]) {
            alert("Invalid Phone. Ask our representative to check membership status")
            
          } else {
            setcustomerData(userData);
            if(userData.isPasswordSet) { // TODO: Check if password is set
              setShowPassword(true);
            } else {
              setNewPassword(true);
            }
          }
        })
        .catch(error => console.log('error', error));
    }

  async function validateUser() {
    const enteredPhoneNumber = phoneNumber.current.value;
    if(enteredPhoneNumber.length < 10) {
      alert("Enter Valid Phone Number");
    } else {
      await checkIfUserExist(enteredPhoneNumber);
    }
  }

  function registerPassword() {
    if(newPwd.current.value === confirmPwd.current.value) {
      //TODO: API Call to add User & Redirect to Home
      updatePassword();
      //navigate("/scan");
    } else {
      alert("Passwords are not matching");
    }
  }

  const updatePassword = async (data) => {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    let raw = JSON.stringify({
      "password": newPwd.current.value
    });

    var requestOptions = {
      method: 'PATCH',
      headers: myHeaders,
      body: raw
    };

    await fetch(backEndUrl + "api/"+userType[rSelected]+"/password/" + customerData.phone , requestOptions)
      .then(response => response.text())
      .then(result => {
        let userData = JSON.parse(result);
        console.log(userData);
        if(userData["message"]) {
          alert(userData["message"]);
        } else {
          //navigate("/", { state: customerData });
          alert("Password Updated. Please login.")
          window.location.reload();
        }
        
      })
      .catch(error => console.log('error', error));
  }

  async function login() {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    let raw = JSON.stringify({
      "phone": phoneNumber.current.value,
      "password": password.current.value
    });

    let requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw
    };

    await fetch(backEndUrl + "api/"+userType[rSelected]+"/login/" , requestOptions)
    .then(response => response.text())
    .then(result => {
      if(JSON.parse(result).token) {
        let tempCustomerData = customerData;
        tempCustomerData["token"] = JSON.parse(result).token;
        if(rSelected === 0)
          navigate("/scan", { state: tempCustomerData });
        else if(rSelected === 1)
          navigate("/partner", { state: tempCustomerData });
        else if(rSelected === 2)
          navigate("/franchise", { state: tempCustomerData });
      } else {
        alert(JSON.parse(result).message)
      }
    })
    .catch(error => alert("Error" + error + "Please Try again"));
  }

  return (
    <div className="App">
      <div>
      <Card
        color="dark"
        style={{width: '20rem', margin: "0 auto", marginTop: "16vh"}}>
        <img
          alt="Zero Gravity"
          src="https://atzerogravity.com/wp-content/uploads/2021/11/ZG_Logo_web.png" />
          <CardTitle tag="h3" style={{color: "white", marginBottom: "15px"}}>Login</CardTitle>
        <CardBody>
          <Form style={{textAlign: "left"}}>
            <FormGroup>

              <ButtonGroup className='radioGroup'>
                <Button
                  color="primary"
                  outline
                  onClick={() => setRSelected(0)}
                  active={rSelected === 0}
                >
                  User
                </Button>
                <Button
                  color="primary"
                  outline
                  onClick={() => setRSelected(1)}
                  active={rSelected === 1}
                >
                  Partner
                </Button>
                <Button
                  color="primary"
                  outline
                  onClick={() => setRSelected(2)}
                  active={rSelected === 2}
                >
                  Franchise
                </Button>
              </ButtonGroup>

            <br/>
              <Label for="phone" style={{color: "white"}}>Phone</Label>
              <Input innerRef={phoneNumber} type="text" style={{marginBottom: "15px"}} placeholder="Enter Phone Number"/>

          
              { showPassword ? <Input type="password" innerRef={password} style={{marginBottom: "15px"}} placeholder="Enter Password"/> : null}
              { newPassword ? <Input type="password" innerRef={newPwd} style={{marginBottom: "15px"}} placeholder="Enter Password"/> : null}
              { newPassword ? <Input type="password" innerRef={confirmPwd} style={{marginBottom: "15px"}} placeholder="Confirm Password"/> : null}
            </FormGroup>
          </Form>
          {showPassword || newPassword ? null : <Button color="light" onClick={(event) => validateUser()} style={{float: "right"}}>Continue</Button>}
          {showPassword ? <Button color="light" onClick={login} style={{float: "right"}}>Login</Button> : null}
          {newPassword ? <Button color="light" onClick={registerPassword} style={{float: "right"}}>Continue Login</Button> : null}
        </CardBody>
      </Card>
        
      </div>
    </div>
  );  
}

export default App;
